// extracted by mini-css-extract-plugin
export default {"row":"hlQ92","cell":"Jvt9f","text":"oPRWz"};